import { EyeOutlined, Loading3QuartersOutlined } from '@ant-design/icons';
import { GetFrontRichiesteIdImmaginiIdDimensioni } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Button } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { PreviewSubmissionImageAttachmentModal } from './PreviewSubmissionImageAttachmentModal';
import { usePreviewSubmissionImageAttachment } from './usePreviewSubmissionImageAttachment';

export interface IPreviewSubmissionImageAttachmentProps {
  submissionId: string;
  attachmentId: string;
  /*
    ICONA - Miniatura upload (widget) - tutti gli elenchi 
    ANTEPRIMA - Dettaglio richiesta e dettaglio procedimento
    ORIGINALE - Nella Modal
  */
  dimension?: GetFrontRichiesteIdImmaginiIdDimensioni;
  width?: number;
  borderRadius?: number;
  height?: number;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}

const Wrapper = styled.div<{ borderRadius?: number }>`
  position: relative;
  display: inline-block;
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: ${({ borderRadius }) =>
    borderRadius !== undefined ? `${borderRadius}px` : '0'};
  &:hover span {
    opacity: 1;
  }
`;

const StyledSpan = styled.span<{ borderRadius: number }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: inherit;
  font-size: 1.2em;
  border-radius: ${({ borderRadius }) =>
    borderRadius !== undefined ? `${borderRadius}px` : '0'};
`;

/**
 * Componente per la visualizzazione di un allegato immagine
 *
 */
export function PreviewSubmissionImageAttachment(
  props: IPreviewSubmissionImageAttachmentProps,
) {
  const {
    submissionId,
    attachmentId,
    dimension,
    width,
    borderRadius,
    height,
    objectFit,
  } = props;
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const { imageInfo, isLoading } = usePreviewSubmissionImageAttachment({
    submissionId,
    attachmentId,
    dimension: dimension ?? GetFrontRichiesteIdImmaginiIdDimensioni.ICONA,
  });

  return (
    <div style={{ width: width ?? 50, height: 'auto' }}>
      {isLoading && (
        <div
          style={{
            width: width ?? 50,
            height: height ?? 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loading3QuartersOutlined spin />
        </div>
      )}

      {!isLoading && imageInfo && (
        <>
          <Button
            onClick={() => setOpen(true)}
            type="text"
            style={{ height: 'auto', padding: 0, border: 'none' }}
          >
            <Wrapper borderRadius={borderRadius ?? 0}>
              <img
                src={imageInfo?.url}
                alt={t('widget-immagine.anteprima', 'Anteprima Immagine')}
                style={{
                  width: width ?? 50,
                  height: height ?? 'auto',
                  borderRadius: borderRadius,
                  objectFit: objectFit,
                }}
              />
              <StyledSpan borderRadius={borderRadius ?? 0}>
                <EyeOutlined />
              </StyledSpan>
            </Wrapper>
          </Button>
          <PreviewSubmissionImageAttachmentModal
            open={open}
            setOpen={setOpen}
            submissionId={submissionId}
            attachmentId={attachmentId}
          />
        </>
      )}
    </div>
  );
}
